import React from "react";
import { Navbar } from "reactstrap";

const Header = () => {
    return (
        <Navbar className="gcn-header">
            <div className="logo gcn-logo-position">
                <img className="logo-img"
                    id="logo-gcn"
                    alt="logo-gcn" />
            </div>
        </Navbar >
    );
};

export default Header;
